import {
  evaluationDataId,
  evaluationDataEng,
  totalSample,
  avgF1Score,
} from '../../utils/data-agate';

const EvaluationTable = ({ isEnglish }) => (
  <>
    <div className='overflow-x-auto shadow-xl rounded-lg mb-2 mx-14 hidden md:block'>
      <table className='min-w-full table-auto rounded-lg overflow-hidden'>
        <thead className='bg-axel-3'>
          <tr>
            {[
              'No',
              'Classification',
              'TBS Sample',
              'Precision',
              'Recall',
              'F1 - Score',
              'Remarks',
            ].map((text, i) => (
              <th
                key={i}
                className='font-medium px-4 py-2 text-left border-b w-max'
              >
                {text}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(isEnglish ? evaluationDataEng : evaluationDataId).map(
            (row, index) => (
              <tr key={index}>
                <td className='px-4 py-2 align-top'>{row.no}</td>
                <td className='px-4 py-2 align-top bg-axel-1'>
                  {row.classification}
                </td>
                <td className='w-32 px-4 py-2 align-top bg-mainBlue-1 text-center'>
                  {row.sample}
                </td>
                <td className='px-4 py-2 align-top text-center'>
                  {row.precision}
                </td>
                <td className='px-4 py-2 align-top text-center'>
                  {row.recall}
                </td>
                <td className='w-32 px-4 py-2 align-top font-bold text-center'>
                  {row.f1}
                </td>
                <td className='px-4 py-2 align-top'>{row.remarks}</td>
              </tr>
            )
          )}
        </tbody>
        <tfoot>
          <tr className='font-medium'>
            <td className='bg-axel-3 px-4 py-2 text-center' colSpan={2}>
              Total Sample
            </td>
            <td className='bg-axel-3 px-4 py-2 text-center'>{totalSample}</td>
            <td className='bg-axel-5 px-4 py-2 font-bold' colSpan={2}>
              {isEnglish ? 'Average F1-Score' : 'F1-Score Rata-Rata'}
            </td>
            <td className='bg-axel-5 px-4 py-2 font-bold text-center'>
              {avgF1Score}
            </td>
            <td className='bg-axel-1'></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <p className='text-center text-neutral-7 mt-2'>
      {isEnglish
        ? 'F1-Score performance evaluation table'
        : 'Tabel evaluasi rata rata f1-score'}
    </p>
  </>
);

export default EvaluationTable;
